const withStudentMessagesApi = (Base) => class extends Base {
  async getAdminStudentMessages() {
    return this.request('/student-messages/admin');
  }

  async searchStudentsForTargeting(query) {
    return this.request(`/student-messages/admin/students-lookup?q=${encodeURIComponent(query)}`);
  }

  async createStudentMessage(payload) {
    return this.request('/student-messages/admin', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async updateStudentMessage(id, payload) {
    return this.request(`/student-messages/admin/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

  async archiveStudentMessage(id) {
    return this.request(`/student-messages/admin/${id}/archive`, { method: 'POST' });
  }

  async deleteStudentMessage(id) {
    return this.request(`/student-messages/admin/${id}`, { method: 'DELETE' });
  }

  async sendStudentMessageEmails(id, mode = 'all') {
    return this.request(`/student-messages/admin/${id}/send-emails`, {
      method: 'POST',
      body: JSON.stringify({ mode })
    });
  }

  async getActiveStudentMessages() {
    return this.request('/student-messages/active');
  }

  async viewStudentMessage(id) {
    return this.request(`/student-messages/${id}/view`, { method: 'POST' });
  }

  async dismissStudentMessage(id) {
    return this.request(`/student-messages/${id}/dismiss`, { method: 'POST' });
  }

  async acknowledgeStudentMessage(id, payload = {}) {
    return this.request(`/student-messages/${id}/acknowledge`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};

export default withStudentMessagesApi;
